import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                JM漫画导航
              </span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              jmcomic-zzz.one 是JM漫画官方入口导航平台，为用户提供最新访问地址、内容导航及使用帮助。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">分类浏览</Link>
              <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <a href="https://jmcomic-zzz.one" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">进入JM漫画</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              热门分类
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新地址</Link>
              <Link to="/category" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">访问指南</Link>
              <Link to="/category" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门推荐</Link>
              <Link to="/category" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">帮助中心</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              免责声明
            </h4>
            <p className="text-foreground-300 text-sm leading-relaxed">
              本网站为JM漫画资源导航平台，所有漫画内容版权归原作者及JM漫画平台所有。如有问题请联系我们。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {currentYear} jmcomic-zzz.one - JM漫画官方入口导航 | 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}